import { Card, CardContent, Typography } from '@mui/material';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import { IEquipment } from '../../types';
import { useTranslation } from 'react-i18next';
import { SectionHeader } from 'components/ui/typography';
import { useEquipmentAccessorColumns } from '../../equipment-accessories';

/** Props for the accessories tab. */
interface AccessoriesTabProps {
  equipment: IEquipment;
}

/**
 * Tab that renders the list of accessories belonging to an equipment.
 *
 * Displays a compact DataGrid when accessories exist,
 * otherwise shows an empty-state message.
 */
export const AccessoriesTab = ({ equipment }: AccessoriesTabProps) => {
  const { t } = useTranslation();

  const accessoriesColumns: GridColDef[] = useEquipmentAccessorColumns();

  return (
    <>
      <SectionHeader
        title={t('entities.equipment.accessories')}
        subtitle="Visualizza e gestisci l'elenco degli accessori legati allo strumento"
      />
      <Card variant="outlined" sx={{ mt: 2 }}>
        <CardContent>
          {equipment?.accessorList === undefined ? (
            <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
              Caricamento…
            </Typography>
          ) : equipment?.accessorList?.length != 0 ? (
            <DataGridPremium
              density="compact"
              rows={equipment.accessorList}
              columns={accessoriesColumns}
              sx={{ border: 'none' }}
              disableRowSelectionOnClick
            />
          ) : (
            <Typography color="text.secondary">
              {t('entities.equipment.noAccessories', 'Nessun accessorio presente.')}
            </Typography>
          )}
        </CardContent>
      </Card>
    </>
  );
};
